export const PHONE = "7338323939";
export const PHONE_LINK = "tel:+917338323939";
export const EMAIL = "falkeentechnologies@gmail.com";
export const EMAIL_LINK = `mailto:${EMAIL}`;

const WA_MSG = encodeURIComponent(
  "Hi Falkeen Technologies, I'm interested in creating a website for my business. I would like to discuss my requirements."
);
export const WHATSAPP_LINK = `https://wa.me/917338323939?text=${WA_MSG}`;

export const waLink = (msg) =>
  `https://wa.me/917338323939?text=${encodeURIComponent(msg)}`;

export const ADDRESS = "Main Bus Stop, Gopala, Shivamogga, Karnataka – 577205, India";
export const MAPS_LINK = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent("Falkeen Technologies, Main Bus Stop, Gopala, Shivamogga, Karnataka 577205, India")}`;

export const LOGO_FULL = "/assets/falkeen-logo-full.png";
export const LOGO_EMBLEM = "/assets/falkeen-emblem.png";

export const MOCK_IMGS = [
  "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxzb2Z0d2FyZSUyMGRhc2hib2FyZHxlbnwwfHx8fDE3OTA1OTI2OTZ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1763718528755-4bca23f82ac3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxzYWFzJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc5MDU5MjcxNnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1686061592689-312bbfb5c055?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxzYWFzJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc5MDU5MjcxNnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxzYWFzJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc5MDU5MjcxNnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1649881927251-46644283751a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxzb2Z0d2FyZSUyMGludGVyZmFjZSUyMHNjcmVlbnNob3R8ZW58MHx8fHwxNzkwNTkyNzE2fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1604536264507-020ce894daf1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxzb2Z0d2FyZSUyMGludGVyZmFjZSUyMHNjcmVlbnNob3R8ZW58MHx8fHwxNzkwNTkyNzE2fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxzb2Z0d2FyZSUyMGRhc2hib2FyZHxlbnwwfHx8fDE3OTA1OTI2OTZ8MA&ixlib=rb-4.1.0&q=85",
];

export const HERO_BG =
  "https://images.unsplash.com/photo-1650327034581-1711a15a5430?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxkYXJrJTIwYWJzdHJhY3QlMjB0ZWNobm9sb2d5JTIwYmFja2dyb3VuZHxlbnwwfHx8Ymx1ZXwxNzkwNTkyNjg5fDA&ixlib=rb-4.1.0&q=85";

export const scrollTo = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
